/**
 * package: com.inq.events
 * class: MouseEvent
 * @extends com.inq.events.Event
 * @constructor
 * @param {string} type
 * @param {Event} originalEvent
 */
com.inq.events.MouseEvent = function(type, originalEvent) {
	com.inq.events.Event.call(this, type, originalEvent);
};
$hxClasses['com.inq.events.MouseEvent'] = com.inq.events.MouseEvent;
/** @private @type {Array} */
com.inq.events.MouseEvent.__name__ = ["com","inq","events","MouseEvent"];
/** @private @type {Function} */
com.inq.events.MouseEvent.__super__ = com.inq.events.Event;
for(var k in com.inq.events.Event.prototype ) com.inq.events.MouseEvent.prototype[k] = com.inq.events.Event.prototype[k];
/** @type {string} */
com.inq.events.MouseEvent.DOUBLE_CLICK = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_DOWN = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_MOVE = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_OUT = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_OVER = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_UP = null;
/** @type {string} */
com.inq.events.MouseEvent.MOUSE_WHEEL = null;
/** @type {string} */
com.inq.events.MouseEvent.ROLL_OUT = null;
/** @type {string} */
com.inq.events.MouseEvent.ROLL_OVER = null;
/** @private @type {boolean} */
com.inq.events.MouseEvent.prototype.m_shiftKey = null;
/** @private @type {null} */
com.inq.events.MouseEvent.prototype.m_relatedObject = null;
/** @private @type {number} */
com.inq.events.MouseEvent.prototype.m_localY = null;
/** @private @type {number} */
com.inq.events.MouseEvent.prototype.m_localX = null;
/** @private @type {number} */
com.inq.events.MouseEvent.prototype.m_delta = null;
/** @private @type {boolean} */
com.inq.events.MouseEvent.prototype.m_ctrlKey = null;
/** @private @type {boolean} */
com.inq.events.MouseEvent.prototype.m_buttonDown = null;
/** @private @type {boolean} */
com.inq.events.MouseEvent.prototype.m_altKey = null;
/** @type {number} */
com.inq.events.MouseEvent.prototype.stageY = null;
/** @type {number} */
com.inq.events.MouseEvent.prototype.stageX = null;
/** @type {boolean} */
com.inq.events.MouseEvent.prototype.shiftKey = null;
/** @type {null} */
com.inq.events.MouseEvent.prototype.relatedObject = null;
/** @type {number} */
com.inq.events.MouseEvent.prototype.localY = null;
/** @type {number} */
com.inq.events.MouseEvent.prototype.localX = null;
/** @type {number} */
com.inq.events.MouseEvent.prototype.delta = null;
/** @type {boolean} */
com.inq.events.MouseEvent.prototype.ctrlKey = null;
/** @type {boolean} */
com.inq.events.MouseEvent.prototype.buttonDown = null;
/** @type {boolean} */
com.inq.events.MouseEvent.prototype.altKey = null;
/** @type {com.inq.events.MouseEvent} */
com.inq.events.MouseEvent.prototype.__class__ = com.inq.events.MouseEvent;
/** @type {string} */
com.inq.events.MouseEvent.CLICK = "click";

